import modal from 'modal';
import Bacon from 'Bacon';
import $ from 'jquery';
import c from 'common';

$(document.body).asEventStream('click', '.confirm-cancel').doAction(c.stopEvent).onValue(function (e) {
  var ruleId = c.$target(e).attr('data-id');
  $('li[data-id='+ruleId+']').find('a.delete-rule-disabled').attr('class','delete-rule');
  $('#delete-wildcard').attr('class', 'button small red delete');
  modal.close();
});
$(document.body).asEventStream('click', '.show-more').doAction(c.stopEvent).map(c.$target).onValue(function ($target) {
  $target.hide();
  $('.confirm-modal ul').addClass('show-all');
  modal.center();
});

export default {
  open: function (options) {
    options.modalClass = 'confirm-modal';
    return modal.open(options.template, Bacon.combineTemplate(options)).doAction(modal.center).doAction(function () {
      $('.show-more').translate('delete-recordings-count', {
        'count': options.howManyMore
      });
    }).flatMap(function () {
      return $('.confirm-delete').asEventStream('click').doAction(c.stopEvent).map(function (event) {
        var ruleId = $(event.target).attr('data-id');
        $('li[data-id='+ruleId+']').hide();
        return {
          confirm: true,
          value: $(event.target).attr('data-value')
        };
      }).merge(modal.closeStream.map({
        confirm: false
      }))
        .take(1).doAction(modal.close).filter('.confirm').map('.value');
    });
  }
};



// WEBPACK FOOTER //
// ./web/js/confirm.js